import axios from "axios";
import React, { useEffect, useState } from "react";
import ReactLoading from "react-loading";
import { useNavigate } from "react-router-dom";
import Logout from "../../../components/Logout";
import { API_URL } from "../../../constants";
import { axiosConfig } from "../../../utils";
import { Footer } from "../../../components/Footer";
import { useTranslation } from 'react-i18next';

function ChoosePlanPage() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const { t } = useTranslation();

  const getOffers = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${API_URL}/offers?status=active&pageLimit=3`,
        axiosConfig(),
      );
      await axios.get(
        `${API_URL}/customers/${localStorage.getItem("CLEENG_CUSTOMER_ID")}/transactions`,
        axiosConfig(),
      );

      const listPlans = (res && res.data && res.data.responseData) || [];
      const promise = listPlans.map((p) =>
        axios.get(`${API_URL}/offers/${p.id}`, axiosConfig()),
      );
      const details = await Promise.all(promise);

      setPlans(
        details ? details.map((d) => {
          const result = d && d.data && d.data.responseData
          const offer = listPlans.find(plan => result.offerId.includes(plan.id))
          result.imageUrl = offer && offer.imageUrl
          return result
        }) : [],
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      // console.log(error);
      if (error && error.response && error.response.status === 401) {
        localStorage.removeItem("CLEENG_CUSTOMER_ID")
        localStorage.removeItem("CLEENG_REFRESH_TOKEN")
        localStorage.removeItem("CLEENG_CUSTOMER_EMAIL")
        localStorage.removeItem("CLEENG_AUTH_TOKEN")
        navigate("/");
      }
    }
  };

  const handleCheckOffers = async () => {
    const res = await axios.get(
      `${API_URL}/customers/${localStorage.getItem(
        "CLEENG_CUSTOMER_ID",
      )}/offers`,
      axiosConfig(),
    );
    const items = (res.data && res.data.responseData.items) || [];
    if (items.length) {
      navigate("/my-account");
      return;
    }
  };

  useEffect(() => {
    getOffers();
    handleCheckOffers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="main">
      <Logout />
      <div className="msd__header__logo"></div>
      <div className="choose-plan">
        <h2>{t("Pricing Plans")}</h2>
        <div className="pricing-plan">
          {loading && (
            <ReactLoading
              className="center mb-4"
              type="spinningBubbles"
              color="#ddd"
            />
          )}
          {!loading &&
            plans.sort((a, b) => a.offerPrice - b.offerPrice).map((plan) => (
              <div key={plan.offerId} className="plan" id={plan.offerId}>
                <h2>{plan.offerTitle}</h2>
                {/* <p>{plan.description}</p> */}
                <img className="planImage" alt="" src={plan.imageUrl} />
                <div className="price">
                  {plan.customerCurrencySymbol + plan.customerPriceInclTax}
                </div>
                <button
                  className="btn msd__button msd__button--confirm"
                  onClick={() => {
                    navigate(`/checkout?offerId=${plan.offerId}`);
                  }}
                >
                  {t("Subscribe")}
                </button>
              </div>
            ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ChoosePlanPage;
